// WHERE AN EKRM CAME FROM. The Model Composer writes an EKRM only as a step towards the custom model
// ekrmBuilt (functions/index.js) builds from it, so that EKRM is not offered anywhere EKRMs are: not
// in Manage EKRM, not as a reference in CreateCustomModel. The composer lists the finished models
// itself instead. EKRMs made in Manage EKRM carry no origin.
export const COMPOSER_ORIGIN = 'composer'

// Takes an ekrm document, or a client built from one: ekrmBuilt copies the origin onto the client,
// and the client's reference_model is the whole ekrm document, which carries it too.
export function isComposerEkrm (doc) {
  if (!doc) return false
  if (doc.origin === COMPOSER_ORIGIN) return true
  return !!(doc.reference_model && doc.reference_model.origin === COMPOSER_ORIGIN)
}
